import { Component } from '@angular/core';
import { take } from 'rxjs/operators';
import { DownloadActionComponent } from './preuzmi-datoteku-dokument.component';

@Component({
  selector: 'app-open-in-tab-action',
  templateUrl: './preuzmi-datoteku-dokument.component.html'
})
export class OpenFileInNewTabActionComponent extends DownloadActionComponent {
  override executeAction(): void {
    this.itemProvider?.item$.pipe(take(1)).subscribe((item: any) => {
      if (!item) {
        return;
      }

      const objectType = item['$itemType'];
      const objectId = item['en~datoteka~id'];
      const renditionName = 'default';
      const isFolder = item['en~datoteka~is_directory'] === true;

      if (isFolder) {
        this.contentDownloadService
          .downloadFolder(objectType, objectId, renditionName)
          .subscribe({
            next: () => {
              this.notificationService.success('Preuzimanje je završeno.');
            },
            error: (error) => {
              const errorMessage = this.getErrorMessage(error);
              this.notificationService.error(
                'Greška kod prezimanja datoteke: ' + errorMessage
              );
            }
          });
        return;
      }

      this.contentDownloadService
        .openFileInNewTab(objectType, objectId, renditionName)
        .subscribe({
          error: (error) => {
            const errorMessage = this.getErrorMessage(error);
            this.notificationService.error(
              'Greška kod otvaranja datoteke: ' + errorMessage
            );
          }
        });
    });
  }
}
